import { render, staticRenderFns } from "./law.vue?vue&type=template&id=2e6ef17e&scoped=true"
import script from "./law.vue?vue&type=script&lang=js"
export * from "./law.vue?vue&type=script&lang=js"
import style0 from "./law.vue?vue&type=style&index=0&id=2e6ef17e&prod&lang=scss&scoped=true"
import style1 from "./law.vue?vue&type=style&index=1&id=2e6ef17e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ef17e",
  null
  
)

export default component.exports